import { jsx as _jsx } from "react/jsx-runtime";
import { FIELDS } from '@src/components/Employee/EditProgram/ProgramFields';
import { ProgramPurpose } from '@src/components/Employee/EditProgram/ProgramPurpose';
import { SummaryCard } from '@src/components/Employee/SummaryCard';
import { ProgramContext } from '@src/contexts/ProgramContextProvider';
import { RuleType } from '@src/types';
import { getSchoolPolicy, requireFieldsOfStudy, requirePickListValue, requireProgramName, requireProvider, requireSchool, } from '@src/utilities/benefitsHelper';
import { getFieldOfStudyName, getSchoolCountryCode, getSchoolName, } from '@src/utilities/programHelper';
import { useLocale } from 'pe-core-frontend';
import { useContext, useMemo } from 'react';
export const ProgramSummary = ({ className, headingClass, title, program, fields, onEdit, }) => {
    const { t, formatToLocalDate } = useLocale();
    const { myBenefits, getPolicy } = useContext(ProgramContext);
    const schoolPolicy = useMemo(() => getSchoolPolicy(myBenefits, program), [myBenefits, program]);
    const programPolicy = useMemo(() => getPolicy(RuleType.PROGRAM, program), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [program]);
    const getValue = (f) => {
        let value;
        switch (f.field) {
            case 'schoolId':
                if (requireSchool(myBenefits, program)) {
                    value = getSchoolName(program);
                }
                break;
            case 'schoolName':
                if (requireProvider(myBenefits, program)) {
                    value = program.schoolName;
                }
                break;
            case 'schoolCountryCode':
                if (requireSchool(myBenefits, program)) {
                    value = getSchoolCountryCode(program);
                }
                break;
            case 'description':
                if (!requireFieldsOfStudy(myBenefits, program)) {
                    value = program.description;
                }
                break;
            case 'programLevelId':
                if (program.programLevelId) {
                    value = program.programLevelName;
                }
                break;
            case 'fieldOfStudyId':
                if (requireFieldsOfStudy(myBenefits, program)) {
                    value = getFieldOfStudyName(program);
                }
                break;
            case 'estCompDate':
                if (program.isSingleExpense)
                    return ''; // Don't display estCompDate for single expense programs
                value = program.estCompDate
                    ? formatToLocalDate(program.estCompDate, { dateStyle: 'medium' })
                    : '';
                break;
            case 'purpose':
                value = program.purpose.isActive ? (_jsx(ProgramPurpose, { clientId: program.clientId, fieldInfo: f, readOnly: true, purpose: program.purpose })) : null;
                break;
            case 'programName':
                if (requireProgramName(myBenefits, program)) {
                    value = program.programName;
                }
                break;
            case 'startDate':
                value = program.startDate
                    ? formatToLocalDate(program.startDate, { dateStyle: 'medium' })
                    : '';
                break;
            case 'custom1':
                if (requirePickListValue(myBenefits, program)) {
                    value = program.custom1;
                }
                break;
        }
        return value;
    };
    const getLabel = (f) => {
        let label;
        if (f.field === 'custom1') {
            label = schoolPolicy?.pickList?.label || '';
        }
        else if (f.field === 'startDate' && program.isSingleExpense) {
            label = programPolicy?.singleExpenseDate?.label;
        }
        else if (f.field === 'startDate') {
            label = t('Start date');
        }
        return label || t(f.label);
    };
    const details = fields
        .map(f => FIELDS.find(s => s.field === f))
        .map(f => ({
        label: getLabel(f),
        value: getValue(f),
    }))
        .filter(({ value }) => !!value);
    return (_jsx(SummaryCard, { className: className, headingClass: headingClass, title: title, details: details, onEdit: onEdit }));
};
